/** @jsx jsx */

import React, { Fragment as _, useContext } from 'react';
import { css, jsx } from '@emotion/core';
import { interactionContext } from './interactionContext';
import isIE from 'services/isIE';

const Content = ({ layout, children }) => {
  //
  // ie collpases content when flex: 1
  // ' hacked ' it by driving the width by layout
  //

  return (
    <div
      css={css`
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        // flex: 1;
        width: ${layout.includes('Two') ? '50%' : '100%'};
        margin: 10px;
      `}
    >
      {children}
    </div>
  );
};

const ClickAndRevealContent = props => {
  const { onClose, children } = props;
  const [columnA, columnB, btn] = children;

  const { layout } = useContext(interactionContext).props;

  const getImg = column =>
    column.props.child === 1 &&
    React.cloneElement(column.props.children[1], { editWrapperType: 0 });

  //
  // ${layout === 'column' && `flex-direction: column;`}
  // layout.includes('column') &&

  // console.log(layout);

  return (
    <div
      css={css`
        width: 100%;
        padding: 50px;
      `}
    >
      <div
        css={css`
          display: flex;
          flex-direction: ${
            {
              'Two column': 'row;',
              'Two column reversed': 'row-reverse;',
              'One column': 'column;',
              'One column reversed': 'column-reverse;',
              'No image': 'column;',
            }[layout]
          }
          width: 100%;
          // min-height: 50vh;

          ${layout.includes('Two') &&
            `
          @media (max-width: 768px) {
            flex-direction: ${
              {
                'Two column': 'column;',
                'Two column reversed': 'column-reverse;',
              }[layout]
            }
          `}
        `}
      >
        <Content layout={layout}>{getImg(columnA) || columnA}</Content>

        {layout !== 'No image' && (
          <Content layout={layout}>{getImg(columnB) || columnB}</Content>
        )}
      </div>
      <div
        css={css`
          display: flex;
          justify-content: center;
          width: 100%;
          margin: 30px 0 0 0;
        `}
      >
        {React.cloneElement(btn, { onClick: () => onClose() })}
      </div>
    </div>
  );
};

export default ClickAndRevealContent;
